import { render } from "./commonFileParse.vue?vue&type=template&id=04b20fe1&scoped=true"
import script from "./commonFileParse.vue?vue&type=script&lang=js"
export * from "./commonFileParse.vue?vue&type=script&lang=js"

import "./commonFileParse.vue?vue&type=style&index=0&id=04b20fe1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b20fe1"]])

export default __exports__